import { createAction } from 'redux-actions';
import { makeActionType } from '../utils';

const namespace = 'SLIDERS';

export const fetchSliders = createAction(makeActionType(namespace, ['FETCH']));
export const setSliders = createAction(makeActionType(namespace, ['SET']));
